<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <div id="index">
    <div class="banner-content">
      <!--轮播-->
      <div class="banner">
        <el-carousel trigger="click" height="800px" arrow="never" :interval="600000">
          <el-carousel-item>
            <img src="https://cdn.blanda.com.cn/assets/img/index/banner3.jpg" width="100%" height="100%" alt="">
            <div class="banner-mark">
              <div class="content banner-mark-content">
                <div class="left-pop" style="width: 50%;" >
                  <div class="banner-mark-content-title " style="color: #ffffff;margin-top: 100px;"><span style="font-weight: bold;font-size: 60px;">Cloud</span>
                    <br>平台生态圈</div>
                  <!--Expose the world and lead the future-->
                  <div class="banner-mark-content-note " style="color: #ffffff;margin-bottom: 12px;">生态圈管理模式覆盖酒店全业态 <br> 全方位助力酒店数字化高速运营</div>
                  <div class="">
                    <!--                    <el-button type="primary" style="padding: 20px 40px;font-size: 18px; background: #258CFF;" @click="contactUsDialogVisible=true">了解详情</el-button>-->
                    <el-button type="primary" @click="contactUsDialogVisible=true" style="padding: 15px 70px;font-size:15px; ">了解详情</el-button>
                  </div>
                </div>

              </div>
            </div>
          </el-carousel-item>
<!--          <el-carousel-item>
            <video   autoplay="autoplay" muted="muted" loop="loop" height="900px"  preload="auto" class="video-container" >
              <source src="https://cdn.blanda.com.cn/assets/img/index/1358.mp4" type="video/mp4">
              您的浏览器不支持 video 标签。
            </video>
            <div class="banner-mark-one">
              <div class="content banner-mark-content">
                <div style="width: 50%">
                  <div class="banner-mark-content-title color-white-fff" style="margin-top: 100px;"><span style="font-weight: bold;font-size: 60px;">Cloud</span> 平台生态圈</div>
                  <div class="banner-mark-content-note  color-white-fff">生态圈管理模式覆盖酒店全业态，全方位助力酒店数字化高速运营</div>
                  <div class="">
                    <el-button type="primary" @click="contactUsDialogVisible=true" style="padding: 15px 70px;font-size:15px; ">了解详情</el-button>
                  </div>
                </div>

              </div>
            </div>
          </el-carousel-item>-->
          <el-carousel-item>
            <video   autoplay="autoplay" muted="muted" loop="loop"  preload="auto" class="video-container">
              <source src="https://cdn.blanda.com.cn/assets/img/index/1444.mp4" type="video/mp4">
              您的浏览器不支持 video 标签。
            </video>
            <div class="banner-mark">
              <div class="content banner-mark-content">
                <div style="width: 50%">
                  <div class="banner-mark-content-title " style="margin-top: 100px;"><span style="font-weight: bold;font-size: 60px;">360°</span>全方位掌控</div>
                  <div class="banner-mark-content-note ">不管何时何地，随时随地 <br> 掌控酒店运营状态</div>
                  <div class="">
<!--                    <el-button type="primary" style="padding: 20px 40px;font-size: 18px; background: #258CFF;" @click="contactUsDialogVisible=true">了解详情</el-button>-->
                    <el-button type="primary" @click="contactUsDialogVisible=true" style="padding: 15px 70px;font-size:15px; ">了解详情</el-button>
                  </div>
                </div>

              </div>
            </div>
          </el-carousel-item>


        </el-carousel>
      </div>
      <!--视频-->
<!--      <div class="banner"  >
        <video id=""  autoplay="autoplay" muted="muted" loop="loop"  preload="auto" class="video-container" playbackrate="0.5">
          <source src="https://cdn.blanda.com.cn/assets/img/index/1358.mp4" type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>
      </div>-->

    </div>
    <!-- 第二部分-->
    <div style="background: #b4daff;">
      <div class="content-two">
        <div class="content-two-content-one">
          <div class="content-two-content-one-abs"></div>
          <div class="content content-two-fex">
            <div>
              <div class="content-two-fex-title color-white-fff">酒店管理系统Cloud一体化平台</div>
              <div class="content-two-fex-note color-white-fff">酒店管理生态圈，为酒店行业提供信息智能化，集团化部署一站式云服务</div>
            </div>
          </div>
          <div class="content content-two-content-one-icon">
<!--            <div class="content-two-content-one-icon-item-abs">更多 ></div>-->
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/1.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/pms.png" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">前台客房</div>
                <div class="content-two-content-one-icon-item-note">一站式智慧解决方案，助力轻松管理，营收倍增</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">前台客房</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>方便快捷</div>
                  <div>分析强大</div>
                  <div>功能全面</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Pms')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/2.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/pos.png" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">餐饮收银</div>
                <div class="content-two-content-one-icon-item-note">借力数字技术，提升餐饮企业供应端实力</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">餐饮收银</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>多种点餐方式</div>
                  <div>聚合收银管理</div>
                  <div>智能后厨管理</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Pos')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/3.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/mms.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">会员管理</div>
                <div class="content-two-content-one-icon-item-note">帮助企业快速建立全渠道营销能力、全域会员营销能力</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">会员管理</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>服务优质</div>
                  <div>简单易用</div>
                  <div>降本增效</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Mms')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/4.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/bms.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">早餐核销</div>
                <div class="content-two-content-one-icon-item-note">简化早餐管理操作，提高员工操作效率</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">早餐核销</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>快速扫描</div>
                  <div>一键完成</div>
                  <div>降低成本</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Zz')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/5.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/ac.png" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">财务总账</div>
                <div class="content-two-content-one-icon-item-note">渗透酒店管理各流程，打造全新财务管理模式</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">财务总账</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>工作效率倍增</div>
                  <div>深度洞察决策</div>
                  <div>实现财务数智化</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Ac')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/6.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/picc.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">采购库存</div>
                <div class="content-two-content-one-icon-item-note">业务数据与采购数据实现互联互通</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">采购库存</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>电子化</div>
                  <div>可视化</div>
                  <div>智能化</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Picc')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/7.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/hr.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">人事薪资</div>
                <div class="content-two-content-one-icon-item-note">打造数据驱动的人才管理，提升人才体验，促进人企双赢</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">人事薪资</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>智能应用</div>
                  <div>智慧决策</div>
                  <div>提升服务</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Hrm')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/8.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/fa.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">固定资产</div>
                <div class="content-two-content-one-icon-item-note">实物资产管理信息化建设</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">固定资产</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>推动业务增长</div>
                  <div>助力成本管理</div>
                  <div>提高工作效率</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Eam')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/9.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/sc.webp" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">宴会销售</div>
                <div class="content-two-content-one-icon-item-note">借力数字技术，提升宴会酒店管理供应端实力</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">宴会销售</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>客户集中管理</div>
                  <div>功能齐全</div>
                  <div>提升成单率和服务品质</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Sc')">了解更多
                </div>
              </div>

            </div>
            <div class="content-two-content-one-icon-item">
              <div class="content-two-content-one-icon-item-card">
                <div class="content-two-content-one-icon-item-icon">
<!--                  <img src="https://cdn.blanda.com.cn/assets/img/index/svg/10.svg" width="100%" height="100%" alt="">-->
                  <img src="https://cdn.blanda.com.cn/assets/img/index/icon/web/eng.png" width="100%" height="100%" alt="">
                </div>
                <div class="content-two-content-one-icon-item-title">工程报修</div>
                <div class="content-two-content-one-icon-item-note">报修、维保，全流程覆盖，时时监控</div>
              </div>
              <div class="content-two-content-one-icon-item-bark-card">
                <div class="content-two-content-one-icon-item-bark-card-title">工程报修</div>
                <div class="content-two-content-one-icon-item-bark-card-note">
                  <div>降低运营成本</div>
                  <div>减少人力成本</div>
                  <div>提高管理效率</div>
                </div>
                <div class="content-two-content-one-icon-item-bark-card-btn" @click="on_link('Eng')">了解更多
                </div>
              </div>

            </div>


          </div>
        </div>
        <!-- 第二部分第二段-->
        <div class="content-two-content-two">
          <div class="content content-two-fex">
            <div>
              <div class="content-two-fex-title mar-top-50">产品价值，数智化管理专家</div>
              <div class="content-two-fex-note title-note-color">致力于酒店行业提供专业软件服务，硬件支撑，助力于企业高效运营</div>
            </div>
          </div>
          <div class="content flex border-radius-10" >
            <div class="flex border-radius-10 div-bar-item">
              <div class="div-bar" :class="div_bar_index==0?'div-bar-active':''" v-on:mouseenter="mouseOver(0)">
                <div class="div-bar-abs" :class="div_bar_index==0?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">功能更全面</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">按照国际标准打造全面的PMS功能模块，提供标准化和定制化产品，为不同规模、不同业态的酒店提供合适的管理系统</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-0">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">功能更全面</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">More comprehensive functions</div>
                  </div>
                </div>
              </div>
              <div class="div-bar" :class="div_bar_index==1?'div-bar-active':''" v-on:mouseenter="mouseOver(1)">
                <div class="div-bar-abs" :class="div_bar_index==1?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">接口更便捷</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">全面的API接口中心，更好的兼容性，帮助酒店布局多触点预定渠道，助力实现营销自动化</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-1">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">接口更便捷</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">interfaces are more convenient</div>
                  </div>

                </div>
              </div>
              <div class="div-bar"  :class="div_bar_index==2?'div-bar-active':''" v-on:mouseenter="mouseOver(2)">
                <div class="div-bar-abs" :class="div_bar_index==2?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">安全、稳定</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">与国内著名云供应商合作，合作的云计算架构为大型网站架构+负载均衡，确保系统的高可用性</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-2">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">安全、稳定</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">Safe and stable</div>
                  </div>
                </div>
              </div>
              <div class="div-bar"  :class="div_bar_index==3?'div-bar-active':''" v-on:mouseenter="mouseOver(3)">
                <div class="div-bar-abs" :class="div_bar_index==3?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">房态与运营监控</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">可远程查看房态、报表，实时了解运营情况，
                        不管何时何地，对酒店了如指掌</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-3">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">房态与运营监控</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">Room status and operation    </div>
                  </div>
                </div>
              </div>
              <div class="div-bar"  :class="div_bar_index==4?'div-bar-active':''" v-on:mouseenter="mouseOver(4)">
                <div class="div-bar-abs" :class="div_bar_index==4?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">全平台快速部署</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">全平台化、移动化，支持电脑、平板、手机、安卓、IOS、Windows、Linux
                        无需安装，云端快速部署，即开即用，减少硬件投入及维护，无感式迭代</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-4">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">全平台快速部署</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">Rapid deployment across all platforms </div>
                  </div>
                </div>
              </div>
              <div class="div-bar"  :class="div_bar_index==5?'div-bar-active':''" v-on:mouseenter="mouseOver(5)">
                <div class="div-bar-abs"  :class="div_bar_index==5?'visibility-visible':'visibility-hidden'">
                  <div class="div-bar-abs-bg">
                    <div class="div-bar-img-con">
                      <div class="div-bar-img-con-title" style="font-weight: bold">一体化平台生态圈</div>
                      <div class="div-bar-img-con-xian mar-top-15"></div>
                      <div class="div-bar-img-con-note mar-top-25">酒店管理前后台Cloud一体化平台系统，一站式服务，维护酒店生态链</div>
                    </div>
                  </div>
                </div>
                <div class="div-bar-img-bg-5">
                  <div class="div-bar-img-con">
                    <div class="div-bar-img-con-title">一体化平台生态圈</div>
                    <div class="div-bar-img-con-xian mar-top-15"></div>
                    <div class="div-bar-img-con-note mar-top-25">Integrated full closure</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 第三部分-->
    <div class="content-three">
      <div class="content">
        <div class="title-font-48 text-align">面向丰富酒店场景的全业务解决方案</div>
        <div class="flex flex-align-items content-three-content flex-flow-column ">
          <div class="content-three-content-top flex">
            <div class="content-three-content-top-item" @click="mouseFaImg(0)" :class="fa_img_inde===0?'content-three-content-top-item-active':''">综合</div>
            <div class="content-three-content-top-item" @click="mouseFaImg(1)" :class="fa_img_inde===1?'content-three-content-top-item-active':''">餐饮</div>
            <div class="content-three-content-top-item" @click="mouseFaImg(2)" :class="fa_img_inde===2?'content-three-content-top-item-active':''">商务</div>
            <div class="content-three-content-top-item" @click="mouseFaImg(3)" :class="fa_img_inde===3?'content-three-content-top-item-active':''">集团</div>
            <div class="content-three-content-top-item" @click="mouseFaImg(4)" :class="fa_img_inde===4?'content-three-content-top-item-active':''">景区</div>
            <div class="content-three-content-top-item" @click="mouseFaImg(5)" :class="fa_img_inde===5?'content-three-content-top-item-active':''">国际</div>
            <div class="content-three-content-top-item-abs" ref="nav-bar-item"></div>
          </div>
          <div class="content-three-content-bottom mar-top-30">
            <div class="content-three-content-bottom-content">
              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===0?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===0?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/33.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-anwd.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">综合型酒店管理解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">Cloud一体化平台全集成服务，为酒店行业提供IT数字化、集团化部署一站式云服务</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Zh')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===1?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===1?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/66.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-jkgbj.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">餐饮零售营销平台解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">新一代云餐饮管理系统，高效稳定，能为不同规模、不同业态的酒店和餐饮企业提供一体化的解决方案</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Restaurant')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===2?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===2?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/22.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-ftjk.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">商务公寓快捷连锁解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">平台强大的功能满足不同类型经营场景的各种需求，信息化管理帮您提高工作效率</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Ams')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>


              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===3?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===3?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/55.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-ythqbh.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">集团化业务解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">多渠道的数据收集及深入分析，对管理作出调整和决策，实现企业与企业的无缝对接，提高集团的办事效率</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Group')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===4?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===4?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/44.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-ptksbs.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">智慧景区票务一卡通解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">赋能景区服务、运营和管理，全面提升景区效益；用科技推动景区产业进步，持续为企业创造价值</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Jq')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-three-content-bottom-content-div" :class="fa_img_inde===5?'display-blook-opacity':'display-none-opacity'">
                <div class="content-three-content-bottom-content-item" >
                  <div class="" :class="fa_img_inde===5?'content-three-content-bottom-content-item-img-active':'content-three-content-bottom-content-item-img'" :style="'background-image:url(' + 'https://cdn.blanda.com.cn/assets/img/index/hotel/77.jpg' + ');'">
                  </div>
                  <div class="content-three-content-bottom-content-item-right">
                    <img src="https://cdn.blanda.com.cn/assets/img/index/cp-jkgbj.png" class="content-three-content-bottom-content-item-right-img">
                    <div class="content-three-content-bottom-content-item-right-content">
                      <div class="content-three-content-bottom-content-item-right-content-titles">国际联号增值产品解决方案</div>
                      <div class="content-three-content-bottom-content-item-right-content-titles-min">一站式平台管理，助力实现规模化增长</div>
                      <div class="content-three-content-bottom-content-item-right-content-note">以客户需求为目标，以客户满意为核心，助力酒店完善管理生态圈</div>
                    </div>
                    <div>
                      <el-button class="dtd-btn-primary" type="primary" @click="on_link('Zz')">查看方案详情</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
    <!-- 第四部分-->
    <div class="content-four">
      <div class="content-four-video">
<!--        <video ref="myVideo"  autoplay="autoplay" muted="muted" loop="loop"  preload="auto" class="content-four-video-container">
          <source src="https://cdn.blanda.com.cn/assets/img/index/dd.mp4"  type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>-->
      </div>

      <div class="content-four-video-mark" v-on:mouseenter="updateTargetValue()" v-on:mouseleave="updateTargetValues()">
        <div class="content" style="height: 100%;">
          <div class="flex flex-align-items flex-justify-content" style="height: 100%;">
            <div style="width: 100%;">
              <div class="flex text-align">
                <div class="padding-bottom-50 padding-top-39" style="width:calc(100% /3);">
<!--                  <div class="title-font-86 color-white-fff">600+</div>-->
                  <div class="title-font-86 color-white-fff">
                    <count-to :start-val="0" :end-val="num_1" :duration="1000" class="card-panel-num" />+
                  </div>
                  <div class="title-font-28 mar-top-10 color-white-fff">合作集团</div>
                </div>
                <div class="border-left padding-bottom-50 padding-top-39" style="width:calc(100% /3);">
                  <div class="title-font-86 color-white-fff"> <count-to :start-val="0" :end-val="num_2" :duration="1000" class="card-panel-num" />+</div>
                  <div class="title-font-28 mar-top-10 color-white-fff">合作客户</div>
                </div>
                <div class="border-left padding-bottom-50 padding-top-39" style="width:calc(100% /3);">
                  <div class="title-font-86 color-white-fff"> <count-to :start-val="0" :end-val="num_3" :duration="1000" class="card-panel-num" />+</div>
                  <div class="title-font-28 mar-top-10 color-white-fff">日均宾客数</div>
                </div>
              </div>
              <div style="width: 100%;border-top: 1px solid rgba(255,255,255,.8);"></div>
              <div class="flex text-align">
                <div class="padding-top-70 padding-bottom-39" style="width:calc(100% /3);">
                  <div class="title-font-86 mar-top-10 color-white-fff"> <count-to :start-val="0" :end-val="num_4" :duration="1000" class="card-panel-num" />+</div>
                  <div class="title-font-28 color-white-fff">年度酒店总间数</div>
                </div>
                <div class="border-left padding-top-70 padding-bottom-39" style="width:calc(100% /3);">
                  <div class="title-font-86 color-white-fff"> <count-to :start-val="0" :end-val="num_5" :duration="1000" class="card-panel-num" />+</div>
                  <div class="title-font-28 mar-top-10 color-white-fff">软件著作权</div>
                </div>
                <div class="border-left padding-top-70 padding-bottom-39" style="width:calc(100% /3);">
                  <div class="title-font-86 color-white-fff"> <count-to :start-val="0" :end-val="num_6" :duration="1000" class="card-panel-num" />+</div>
                  <div class="title-font-28 mar-top-10 color-white-fff">专业团队</div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
    <!-- 第五部分-->
    <div class="content-five">
        <div class="content-five-content">
            <div class="title-font-48 text-align">客户专业的选择</div>
            <div class="content-title-note text-align title-note-color">知名酒店集团合作与信赖 <span style="color: #007FFF;margin-left: 10px;cursor: pointer" @click="on_link('Hyal')">查看更多案例 ></span></div>
            <div class="flex mar-top-100">
              <div class="logo-content">
                <!--logo第一部分轮播-->
                <div class="logo-content-item ">
                  <div class="logo-content-item-content" style="animation-duration:90s">
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-11.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-10.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-11.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-12.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-13.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-14.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-15.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-16.png"  height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-17.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="logo-content-item-content" style="animation-duration:90s">
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-13.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-10.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-11.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-12.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-13.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-14.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-15.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-16.png"  height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-17.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <!--logo第二部分轮播-->
                <div class="logo-content-item ">
                  <div class="logo-content-item-content" style="animation-duration:80s">
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="logo-content-item-content" style="animation-duration:80s">
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <!--logo第三部分轮播-->
                <div class="logo-content-item ">
                  <div class="logo-content-item-content" style="animation-duration:90s">
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-10.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-11.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-12.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-13.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-14.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-15.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-16.png"  height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-17.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-12.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="logo-content-item-content" style="animation-duration:90s">
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-10.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-11.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-12.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-13.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-14.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-15.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-16.png"  height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-17.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-3.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>

                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-5.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-7.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-2.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-4.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-6.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-8.png" height="50%" alt="">
                      </div>
                    </div>
                    <div class="logo-item-right">
                      <div class="logo-item ">
                        <img src="https://cdn.blanda.com.cn/assets/img/index/logo-15.png" height="50%" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


        </div>
    </div>
    <ContactUs :hidden="contactUsDialogVisible" @close="contactUsDialogVisible=false"></ContactUs>
<!--    <Join :hidden="contactUsDialogVisible" @close="contactUsDialogVisible=false"></Join>-->
  </div>
</template>
<script>
import ContentImg from "@/components/ContentImg/index";
import ContactUs from "@/components/ContactUs/index";
import Join from "@/components/Join/index";
import CountTo from 'vue-count-to'
/*中文*/
import zhcnLocale from 'element-ui/lib/locale/lang/zh-CN';
// import iviewZhCnLocale from 'iview/src/locale/lang/zh-CN';
/*英文*/
import enLocale from 'element-ui/lib/locale/lang/en';
// import iviewEnUsLocale from 'iview/src/locale/lang/en-US';
/*繁体中文*/
import zhtwLocale from 'element-ui/lib/locale/lang/zh-TW';
// import iviewZhTWLocale from 'iview/src/locale/lang/zh-TW';
/*法语*/
import frLocale from 'element-ui/lib/locale/lang/fr';
// import iviewFrLocale from 'iview/src/locale/lang/fr-FR';
/*立陶宛语*/
import itLocale from 'element-ui/lib/locale/lang/it';
// import iviewITLocale from 'iview/src/locale/lang/it-IT';
/*日语*/
import jaLocale from 'element-ui/lib/locale/lang/ja';
// import iviewJaLocale from 'iview/src/locale/lang/ja-JP';
/*韩语*/
import koLocale from 'element-ui/lib/locale/lang/ko';
// import iviewKoLocale from 'iview/src/locale/lang/ko-KR';
/*蒙古语*/
import mnLocale from 'element-ui/lib/locale/lang/mn';
// import iviewNmLocale from 'iview/src/locale/lang/mn-MN';
/*泰语*/
import thLocale from 'element-ui/lib/locale/lang/th';
// import iviewThLocale from 'iview/src/locale/lang/th-TH';
/*越南语*/
import viLocale from 'element-ui/lib/locale/lang/vi';
import {getLang, LangTypeList} from "@/api";
import {Local} from "@/utils/storage";
export default {
  name: "Index",
  components: {
    ContentImg,
    ContactUs,
    Join,
    CountTo,
  },
  data() {
    return {
      bannereSrc:'https://cdn.blanda.com.cn/assets/img/index/banner.png',
      stat:true,
      div_bar_index:0,
      fa_img_inde:0,
      contactUsDialogVisible:false,//弹窗
      num_1:400,
      num_2:1100,
      num_3:8000,
      num_4:4500,
      num_5:25,
      num_6:50,
      langTypeList:[],
      langType:undefined,
      lang_code:'zh-CN',
    };
  },
  created() {
    this.getLangTypeList()
    this.getLangJsonAll(this.lang_code);
  },
  methods: {
    mouseOver(val){
      this.div_bar_index=val;
    },
    mouseFaImg(val){
      this.fa_img_inde=val;
      this.$refs['nav-bar-item'].style.left=(72 * val) +"px";
    },
    //更新计数器
    updateTargetValue() {
      this.num_1=600;
      this.num_2=1500;
      this.num_3=8100;
      this.num_4=4600;
      this.num_5=26;
      this.num_6=51;
    },
    updateTargetValues() {
      this.num_1=400;
      this.num_2=1100;
      this.num_3=8000;
      this.num_4=4500;
      this.num_5=25;
      this.num_6=50;
    },
    on_link(str){
      /*const href = this.$router.resolve({
        name: str,
      }).href;
      //打开新的页面 到 href 这个页面
      window.open(href, "_self");*/
      this.$router.push({
        name:str,
      }, () => {})
    },
    // 获取语言类型
    getLangTypeList(){
      LangTypeList({}).then(res => {
        this.langTypeList = res.data.list
      }).catch(() => {
        this.loading = false
      })
    },
    setLang(type){
      this.$nextTick(e => {
        // this.$i18n.locale = this.langType;
        // this.$i18n.locale = type;
        this.$store.state.themeConfig.themeConfig.globalI18n = type;
        this.$i18n.locale = type;
      })
    },
    //获取所有的翻译
    getLangJsonAll(lang){
      getLang().then((res) => {
        // Local.clear();
        // Session.clear()
        Local.remove('themeConfigPrev');
        this.$store.state.themeConfig.themeConfig.globalI18n = lang;
        const messages = {
          'zh-CN': {
            ...zhcnLocale,
            ...res.content['zh-CN'],
          },
          'en-US': {
            ...enLocale,
            ...res.content['en-US'],

          },
          'zh-Hant': {
            ...zhtwLocale,
            ...res.content['zh-Hant'],

          },
          'fr-FR': {
            ...frLocale,
            ...res.content['fr-FR'],

          },
          'it-IT': {
            ...itLocale,
            ...res.content['it-IT'],

          },
          'ja-JP': {
            ...jaLocale,
            ...res.content['ja-JP'],

          },
          'ko-KR': {
            ...koLocale,
            ...res.content['ko-KR'],

          },
          'mn-MN': {
            ...mnLocale,
            ...res.content['mn-MN'],

          },
          'th-TH': {
            ...thLocale,
            ...res.content['th-TH'],

          },
          'vi-VN': {
            ...viLocale,
            ...res.content['vi-VN'],

          }
        };
        this.$store.state.themeConfig.themeConfig.globalI18nMess =messages;
        Local.set('themeConfigPrev', this.$store.state.themeConfig.themeConfig);
        this.$nextTick(e => {
          this.$i18n.locale = lang;
        })
      });
    }
  },
  mounted() {
  },
};

</script>
<style scoped >

/*第二部分 start*/
.content-two{
  width: 100%;
  height: 2010px;
  z-index: 1;
  position: relative;
  overflow-y: hidden;
}
.content-two::-webkit-scrollbar {
  width: 0;
}
.content-two::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.content-two:before {
  content: "";
  position: absolute;
  bottom: -50px;
  left: calc((50% - 600px) / 3);
  width: 508px;
  height: 300px;
  background-image: url("https://cdn.blanda.com.cn/assets/img/circle.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  animation: trantale1 6s 3s linear infinite forwards;
  z-index: 1;
}
@keyframes trantale1 {
  0% {
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  25% {
    transform: translate(-40px, -40px);
  }
  50% {
    transform: translate(60px, -60px);
  }
  100% {
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}
.content-two-content-one{
  width: 100%;
  height: 880px;
  background: linear-gradient(180deg, #1573FC 0%, #4AA3FE 100%);
  position: relative;
  z-index: 1;
}
.content-two-content-one:after {
  /*background-color: #4aa3fe;*/
  background: linear-gradient(180deg, #1573fc 10%, #4aa3fe 100%);
  content: '';
  width: 160%;
  height: 1040px;
  position: absolute;
  left: -30%;
  top:0%;
  z-index: -1;
  border-radius: 0 0 50% 50%;
}

.content-two-content-one-abs{
  width: 200px;
  height: 500px;
  background-image: url("https://cdn.blanda.com.cn/assets/img/index/bg-tiao.png");
  background-repeat: no-repeat;
  background-position:bottom left;
  background-size: 200px auto;
  position: absolute;
  left: 0px;
  bottom: -290px;
  z-index: 0;

}
.content-two-content-one-icon{
  /*background: rgba(255,255,255,.1);*/
  /*background: red;*/
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 15px;
  /*height: 450px;*/
  /*padding-top: 60px;*/
}
.content-two-content-one-icon-item{
  width: 224px;
  margin-right: 20px;
  height: 270px;
  display: flex;
  flex-flow: column;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.content-two-content-one-icon-item-abs{
  position: absolute;
  left: 50%;
  bottom: -100px;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
}
.content-two-content-one-icon-item:nth-of-type(1){
  margin-bottom: 20px;
}
.content-two-content-one-icon-item:nth-of-type(2){
  margin-bottom: 20px;
}
.content-two-content-one-icon-item:nth-of-type(3){
  margin-bottom: 20px;
}
.content-two-content-one-icon-item:nth-of-type(4){
  margin-bottom: 20px;
}
.content-two-content-one-icon-item:nth-of-type(5){
  margin-bottom: 20px;
  margin-right: 0px;
}
/*.content-two-content-one-icon-item:nth-of-type(6){
  margin-bottom: 20px;
  margin-right: 0px;
}*/
.content-two-content-one-icon-item:nth-of-type(10){
  margin-right: 0px;
}
.content-two-content-one-icon-item-card{
  background: #ffffff;
  border-radius: 15px;
  display: flex;
  flex-flow: column;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: scale(1);
  /*opacity: 1;*/
  transition: all .8s ease;
}
.content-two-content-one-icon-item-bark-card{
  /*background: #4AA3FE ;*/
  background: #1169fe;
  /*background: #7dbaf6;*/
  border-radius: 15px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  /*opacity: 0;*/
  transition: all .5s ease;
}
.content-two-content-one-icon-item-bark-card-title{
  color: #ffffff;
  /*color: #090808;*/
  line-height: 22px;
  font-size: 20px;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-two-content-one-icon-item-bark-card-note{
  color: #ffffff;
  /*color: #2c2e30;*/
  line-height: 25px;
  font-size: 15px;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  display: flex;
  flex-flow: column;
}
.content-two-content-one-icon-item-bark-card-btn{
  width: 50%;
  padding: 6px 15px;
  background: #ffffff;
  color: #258cff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.content-two-content-one-icon-item:hover .content-two-content-one-icon-item-card{
  transform: scale(.9);
  /*opacity: 0;*/
}
.content-two-content-one-icon-item:hover .content-two-content-one-icon-item-bark-card{
  transform: scale(1);
  opacity: 1;
}

.content-two-content-one-icon-item-i{
  width: 160px;
}
.content-two-content-one-icon-item-icon{
  text-align: center;
  width: 55px;
  height: 55px;
  margin-top: 40px;
}
.content-two-content-one-icon-item-title{
  text-align: center;
  width: 80%;
  line-height: 1;
  color: rgba(44, 46, 48, 100);
  font-size: 20px;
  margin-top: 35px;
}
.content-two-content-one-icon-item-note{
  text-align: center;
  width: 75%;
  color: #7c8087;
  /*color: #151515;*/
  font-weight: normal;
  font-size: 15px;
  margin-top: 20px;
  line-height: 25px;
  height: 55px;
  overflow: hidden;
}


.content-two-content-two{
  margin-top: 130px;
  width: 100%;
  height: 1000px;
  background-image: url("https://cdn.blanda.com.cn/assets/img/index/two-bg3.png");
  background-repeat: no-repeat;
  background-position:bottom;
  background-size: 100% 100%;
  position: relative;
}

.content-two-fex{
  text-align: center;
  padding: 120px 0 80px 0;
}
.content-two-fex-title{
  font-size: 48px;
}
.content-two-fex-note{
  font-size: 17px;
  /*color: #8596B8;*/
  margin-top: 20px;
}
.content-two-img{
  display: flex;
}
.div-bar-item{
  width: 100%;
  position: relative;
  z-index: 2;
}
.div-bar{
  width: 180px;
  height: 400px;
  border-right: 1px solid #eeeeee;
  background: #ffffff;
  /*transition: width 0.1s ease;
  -webkit-transition: width 0.1s ease;
  position: relative;*/
  margin-right: 10px;
  border-radius: 5px;
}
.div-bar:nth-of-type(1){
  margin-right: 10px;
}
.div-bar:nth-last-of-type(1){
  margin-right: 0px;
}
.div-bar-abs{
  /*display: none;*/
  position: absolute;
  width: 250px;
  height: 400px;
  background: linear-gradient(172deg, #40A4FB 0%, #0152FF 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /*overflow: hidden;*/
  border-radius: 5px;
  overflow: hidden;
}
.div-bar-abs-bg{
  width: 250px;
  height: 100%;
  background-image: url("https://cdn.blanda.com.cn/assets/img/index/cp-a.png");
  background-repeat: no-repeat;
  background-size: auto 250px;
  background-position: bottom;
}

.div-bar-active{
  width: 250px;

}
.div-bar:hover{
  width: 250px;
}
.div-bar:nth-of-type(1){
  border-radius: 10px 10px 10px 10px;
}
.div-bar:nth-of-type(6){
  border-radius: 10px 10px 10px 10px;
}

.div-bar-img-bg-0{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/11.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 270px;
  overflow: hidden;
}
.div-bar-img-bg-1{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/22.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 270px;
  overflow: hidden;
}
.div-bar-img-bg-2{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/33.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 275px;
  overflow: hidden;
}
.div-bar-img-bg-3{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/44.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 270px;
  overflow: hidden;
}
.div-bar-img-bg-4{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/55.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 275px;
  overflow: hidden;
}
.div-bar-img-bg-5{
  width: 100%;
  height: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/cpicon/66.png");
  background-size: auto 120px;
  background-repeat: no-repeat;
  background-position: 70px 280px;
  overflow: hidden;
}
.div-bar-img-con{
  padding: 70px 15px;
}
.div-bar-active .div-bar-img-con{
  padding: 0px 45px;
}
.div-bar:hover .div-bar-img-con{
  padding: 0px 45px;
}
.div-bar-img-con-xian{
  width: 27px;
  height: 3px;
  background: linear-gradient(0deg, #007FFF 0%);
}
.div-bar-active .div-bar-img-con-xian{
  height: 0px;
}
.div-bar:hover:hover .div-bar-img-con-xian{
  height: 0px;
}
.div-bar-img-con-title{
  /*height: 40px;*/
  font-size: 20px;
  color: #222222;
}
.div-bar-active .div-bar-img-con-title{
  margin-top: 40px;
  /*height: 60px;*/
  font-size: 20px;
  color: #ffffff;
}
.div-bar:hover .div-bar-img-con-title{
  font-size: 20px;
  color: #ffffff;
}
.div-bar-img-con-note{
  font-size: 15px;
  color: #767e89;
  width: 100%;
  max-height: 200px;
  overflow: hidden;
}
.div-bar-active .div-bar-img-con-note{
  font-size: 16px;
  color: #FFFFFF;
  width: 100%;
  height: 100%;
  line-height: 28px;
}
/*第二部分 end*/
/*第五部分 start*/
.content-five{
  width: 100%;
  height: 650px;
  background: #F7F9FB;
  /*background: red;*/
  padding-top: 100px;
}
@media screen and (min-width: 1300px){
  .content-five-content{
    width: 1500px;
    margin: 0 auto;
  }

}
@media screen and (max-width: 1300px){
  .content-five-content{
    width: 1200px;
    margin: 0 auto;
  }

}

.logo-content{
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.logo-content-item{
  display: flex;
}
.logo-content-item:hover  .logo-content-item-content {
  animation-play-state: paused;
}
.logo-content-item:before{
  /*background-image: -webkit-linear-gradient(left,#ebedf0 20%,rgba(235,237,240,0));*/
  background-image: -webkit-linear-gradient(left,#F7F9FB 20%,rgba(235,237,240,0));
  content: "";
  height: 120%;
  left: -15px;
  position: absolute;
  top: -10px;
  width: 100px;
  z-index: 2;
}
.logo-content-item:after{
  /*background-image: -webkit-linear-gradient(right,#ebedf0 20%,rgba(235,237,240,0));*/
  background-image: -webkit-linear-gradient(right,#F7F9FB 20%,rgba(235,237,240,0));
  content: "";
  height: 120%;
  position: absolute;
  right: -15px;
  top: -10px;
  width: 100px;
  z-index: 2;
}


.logo-content-item-content{
  display: flex;
  animation: CasePlay-move 10s linear infinite;
  flex: 0 0 1200px;
}

@keyframes CasePlay-move {
  0% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(-100%);
    transform: translate(-100%);
  }
}

.logo-item{
  height: 90px;
  width: 185px;
  padding: 0 10px;
  transition: opacity .3s ease-in-out;
  box-shadow: 5px 5px 13px 0px rgba(213,221,239,0.8);
  /*box-shadow: 10px 10px 13px 0px rgba(100,221,239,0.41);*/

  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-item-right{
  padding-bottom: 16px;
  padding-right: 16px;
}

/*第五部分 end*/
.banner-content{
  position: relative;
  height: 800px;
  width: 100%;
}
.banner{
  position: relative;
  height: 800px;
  width: 100%;
}
.video-container{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-mark{
  width: 100%;
  height: calc(100%);
  /*background: transparent;*/
  position:absolute;
  top:0;
  z-index: 2;
}
.banner-mark-one{
  width: 100%;
  height: calc(100%);
  position:absolute;
  top:0;
  z-index: 2;
  /*background: linear-gradient(90deg,rgba(175,204,240,1) 0%,rgba(175,204,240,0.5) 50%, rgba(0,0,0,0) 70%);*/
  /*background: linear-gradient(90deg, rgb(255, 255, 255) 0%,rgba(225, 225, 225,0.6) 50%, rgba(219, 227, 236,0) 70%);*/
  /*background: linear-gradient(90deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.1) 30%, rgba(219, 227, 236,0) 50%);*/
  /*background: linear-gradient(90deg, rgba(200, 227, 252,1) 0%,rgba(200, 227, 252,0.3) 50%, rgba(219, 227, 236,0) 70%);*/
  background: linear-gradient(90deg, rgb(136, 183, 231) 0%,rgba(132, 179, 226,.8) 30%,rgba(132, 179, 226,.6) 40%, rgba(219, 227, 236,0) 70%);
}
.banner-mark-content{
  height: 100%;
  display: flex;
  align-items: center;

}
.banner-mark-content-title{
  /*margin-top: 50px;
  font-size: 65px;
  font-weight: 500;*/
  /*color: #121315;*/
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 56px;
  white-space: nowrap;
  margin-bottom: 40px;
}
.banner-mark-content-note{
  width: 60%;
  height: 90px;
  /*height: 90px;
  font-size: 23px;
  font-weight: normal;*/
  /*color: #000000;*/
  /*color: #ffffff;*/
  font-size: 23px;
  font-style: normal;
  font-weight: 400;
  line-height: 35px;
  margin-bottom: 63px;
  /*color: #282828;*/
  /*background: red;*/
  /*color: #ffffff;*/
}

/*第三部分 start*/
.content-three{
  /*background: #E5F0FE;*/
  background: #ffffff;
  height: 900px;
  /*background-image: url("https://cdn.blanda.com.cn/assets/img/index/three-bg.png");*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  z-index: 100;
  margin-top: -100px;
  padding-top: 100px;
}
.content-three-content{

}
.content-three-content-top{
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 56px 0 40px;
  position: relative;
}
.content-three-content-top-item{
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: rgb(23, 26, 29);
  width: 72px;
  height: 40px;
  line-height: 40px;
  /*padding: 8px 20px;*/
  text-align: center;
  -webkit-transition: color .5s;
  transition: color .5s;
  z-index: 1;
}
.content-three-content-top-item-abs{
  width: 72px;
  left: 0px;
  /*background-color: #007FFF;*/
  background-color:rgb(23, 26, 29);

  border-radius: 20px;
  color: #fff;
  height: 40px;
  position: absolute;
  -webkit-transition: left .3s;
  transition: left .3s;
  z-index: 0;
}
.content-three-content-top-item-active{
  color: rgb(255, 255, 255);
}
.content-three-content-bottom{
  width: 100%;
  height: 450px;
  display: flex;

}
.content-three-content-bottom-content{

}
.content-three-content-bottom-content-div{
  position: absolute;
  /*opacity: 1;*/
  /*transition: opacity .8s;*/
}
.content-three-content-bottom-content-item{
  display: flex;

  height: 450px;
  margin: 0 auto;
  overflow: hidden;
  width: 1200px;
  border-radius: 16px;
}
.content-three-content-bottom-content-item-img{
  background: #ffffff;
  background-position: top;
  background-repeat: no-repeat;
  background-size: auto 100%;
  height: 450px;
  transition: background-size 1s;
  width: 588px;
}
.content-three-content-bottom-content-item-img-active{
  background: #ffffff;
  background-position: top;
  background-repeat: no-repeat;
  background-size: auto 110%;
  height: 450px;
  transition: background-size 1s;
  width: 588px;
}
.content-three-content-bottom-content-item-right{
  /*background: linear-gradient(90deg, rgba(0, 127, 255, 0.3) 0%, #007FFF 100%);*/
  /*background: #171a1f;*/
  background:rgba(0,0,0,.85);
  color: #ffffff;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  justify-items: left;
  overflow: hidden;
  padding: 80px 55px 43px;
  position: relative;
}

.content-three-content-bottom-content-item-right-img{
  position: absolute;
  width: 300px;
  z-index: 0;
  top: 17px;
  right: -59px;
}
.content-three-content-bottom-content-item-right-content{

}

.content-three-content-bottom-content-item-right-content-titles{
  font-size: 32px;
  font-weight: 500;
  margin: 8px 0;
}
.content-three-content-bottom-content-item-right-content-titles-min{
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-image: -webkit-linear-gradient(left,#69b3ff,#0082ff 25%);
  /*color: #0052ff;*/
  font-size: 20px;
  font-weight: 500;
}
.content-three-content-bottom-content-item-right-content-note{
  /*color: hsla(0,0%,100%,.8);*/
  display: -webkit-box;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 58%;
  margin-top: 30px;
  height: 90px;
  overflow: hidden;
}
.dtd-btn-primary{
  background: #007fff;
  color: #ffffff;
  border-radius: 6px;
  padding: 9px 22px;
  font-size: 18px;
  height: 44px;
  margin-bottom: 30px;
  cursor: pointer;
}


/*第三部分 end*/
/*第四部分 start*/
.content-four{
  position: relative;
  height: 800px;
  width: 100%;
  overflow: hidden;
}
.content-four-video{
  position: relative;
  height: 800px;
  width: 100%;
  background: url("https://cdn.blanda.com.cn/assets/img/index/dt.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  animation: zoomInOut 40s ease infinite;
}
@keyframes zoomInOut {
  0% { transform: scale(1); } /* 初始状态，不放大 */
  25% { transform: scale(1.25); } /* 中间状态，放大到1.5倍 */
  50% { transform: scale(1.5); } /* 中间状态，放大到1.5倍 */
  75% { transform: scale(1.75); } /* 中间状态，放大到1.5倍 */
  100% { transform: scale(2); } /* 最终状态，返回正常大小 */
}

.content-four-video-container{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content-four-video-mark{
  width: 100%;
  height:100%;
  /*background: transparent;*/
  /*background: linear-gradient(90deg, rgba(1,30,235,.39) 0%, rgba(156,214,233,.39) 100%);*/
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(2, 2, 2, 0.3) 100%);
  position:absolute;
  top:0;
  z-index: 2;
}


/*第四部分 end*/


</style>
<style>
.banner .el-carousel__button{
  width: 80px;
  height: 4px;
  border-radius: 2px;
  background: #ffffff;
  opacity: 1;
}
.banner .el-carousel__indicator.is-active button {
  display: block !important;
  background: #409eff;
}


</style>
